module.exports = __webpack_public_path__ + "static/media/barefoot_topframe.fecfedf9.png";